module.exports = __webpack_public_path__ + "icon-4.svg?2391038e8bd3b73b7cafb8200e9f597c";